import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonItem, IonAlert, useIonViewDidEnter } from '@ionic/react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import { ServerUrl, VerifyPassword } from '../../constants';
import { AppContext } from "../../context/appContext";
import './styles.css';

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const [password, setPassword] = useState<string>('');
  const [passwordFocus, setPasswordFocus] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordFocus, setNewPasswordFocus] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [confirmPasswordFocus, setConfirmPasswordFocus] = useState<boolean>(false);
  const [messageText, setMessageText] = useState<string>('');
  const [messageHeader, setMessageHeader] = useState<string>('Error');
  const [userInfo, setUserInfo] = useState<any>(null);

  useIonViewDidEnter(() => {
    setPassword('');
    setNewPassword('');
    setConfirmPassword('');
    axios.get(`${ServerUrl}/Auth/getAccountInfo`, {
      headers: {
        'Authorization': "Bearer " + CurrentUser.token,          
      }
    }).then(res => {
      setUserInfo(res.data);
    }, err => {
      alert("Fail to get user info.")
    });
  });

  const changePassword = () => {
    var message = '';

    if (!password) {
      message += 'Old password is required.<br>'
    }
    else if (!newPassword) {
      message += 'New password is required.<br>'
    }
    else if (newPassword !== confirmPassword) {
      message += 'New passwords do not match.<br>'
    } else if (newPassword.length < 8) {
      message += 'New password must have at least 8 characters.\r\n';
    } else if (!VerifyPassword(newPassword)) {
      message += 'Password must contain at least one numeric digit and a special character, and has more than 7 characters.<br>'
    }

    if (message.length > 0) {
      setMessageHeader('Error');
      setMessageText(message);
    }
    else {
      axios.post(`${ServerUrl}/Auth/changepassword`, {username: password, password: newPassword}, {
        headers: {
          'Authorization': "Bearer " + CurrentUser.token,          
        }
      }).then(res => {
        setMessageHeader('Success');
        setMessageText('Your password is changed.');
      }, err => {
        setMessageHeader('Error')
        setMessageText("Fail to change your password.");
      });
    }
  }

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
        <div style={{width: '600px', margin: 'auto', padding: '20px'}}>

        <div style={{fontSize: '28px', fontWeight: 'bold', marginBottom: '20px'}}>My Account</div>

          <IonGrid>
          <IonRow>
              <IonCol size="4" className='nameCell'>Username</IonCol>
              <IonCol size="8" className='nameCell'>{userInfo?.username}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4" className='nameCell'>Email</IonCol>
              <IonCol size="8" className='nameCell'>{userInfo?.email}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4" className='nameCell'>First name</IonCol>
              <IonCol size="8" className='nameCell'>{userInfo?.firstname}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4" className='nameCell'>Last name</IonCol>
              <IonCol size="8" className='nameCell'>{userInfo?.lastname}</IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="4" className='nameCell'>Region</IonCol>
              <IonCol size="8" className='nameCell'>{userInfo?.region}</IonCol>
            </IonRow>
          </IonGrid>

          <div style={{fontSize: '28px', fontWeight: 'bold', marginBottom: '20px', marginTop: '40px'}}>Change Password</div>

          <div>
              <div className={`InputContainer ${passwordFocus ? "InputFocused" : ""}`}>
                  <div style={{paddingLeft: '0px', height: '28px'}}></div>
                  <IonItem color="transparent" lines="none">
                    <span style={{fontSize: '24px'}}>
                    <IonInput min='0'  type="password" value={password} placeholder="Old Password"
                      onIonChange={e => setPassword(e.detail.value!)} onFocus={() => setPasswordFocus(true)} onBlur={() => setPasswordFocus(false)}>
                    </IonInput>
                    </span>
                  </IonItem>
              </div>
              <div className={`InputContainer ${newPasswordFocus ? "InputFocused" : ""}`}>
                  <div style={{paddingLeft: '0px', height: '28px'}}></div>
                  <IonItem color="transparent" lines="none">
                    <span style={{fontSize: '24px'}}>
                    <IonInput min='0'  type="password" value={newPassword} placeholder="New Password"
                      onIonChange={e => setNewPassword(e.detail.value!)} onFocus={() => setNewPasswordFocus(true)} onBlur={() => setNewPasswordFocus(false)}>
                    </IonInput>
                    </span>
                  </IonItem>
              </div>

              <div className={`InputContainer ${confirmPasswordFocus ? "InputFocused" : ""}`}>
                  <div style={{paddingLeft: '0px', height: '28px'}}></div>
                  <IonItem color="transparent" lines="none">
                    <span style={{fontSize: '24px'}}>
                    <IonInput min='0'  type="password" value={confirmPassword} placeholder="New Password Confirmed"
                      onIonChange={e => setConfirmPassword(e.detail.value!)} onFocus={() => setConfirmPasswordFocus(true)} onBlur={() => setConfirmPasswordFocus(false)}>
                    </IonInput>
                    </span>
                  </IonItem>
              </div>
          </div>

          <div className='ChangeButton' onClick={changePassword} >
            <span>Change password</span>
          </div>

        </div>
        <IonAlert 
              isOpen={messageText.length > 0} 
              onDidDismiss={()=> setMessageText('')}
              header={messageHeader}
              subHeader={''}
              message={messageText}
              buttons={['OK']}
          />
      </IonContent>
    </IonPage>
  );
};

export default Home;
